import { faqThemeBodySchema } from "@redotech/redo-support-common/faq/faq-body-schema";

export const updateTheme = {
  name: "updateTheme" as const,
  input: faqThemeBodySchema,
  output: faqThemeBodySchema,
};
